import { FormControlLabel, Radio } from '@mui/material';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { usePromiseTracker } from 'react-promise-tracker';

export const BonusPaid = ({ disableNagativeOrVoid, isRadioButtonEditable }: { disableNagativeOrVoid: boolean; isRadioButtonEditable?: boolean }) => {
  const { control, setValue } = useFormContext();
  const isChecked = useWatch({ name: 'bonusPaid' });
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disableNagativeOrVoid && !isSaveModApiCalling && isRadioButtonEditable !== false) {
      const newValue = !isChecked;
      setValue('forfeitBonus', false, { shouldDirty: true });
      setValue('bonusPaid', newValue, { shouldDirty: true });
    }
  };

  return (
    <Controller
      control={control}
      name={'bonusPaid'}
      render={({ field: { onChange, value, ...rest } }) => {
        return (
          <FormControlLabel
            name={'bonusPaid'}
            key={'Bonus Paid'}
            control={
              <Radio
                name="bonusPaid"
                checked={isChecked}
                disabled={disableNagativeOrVoid || isSaveModApiCalling || isRadioButtonEditable === false}
                onClick={handleClick}
                {...rest}
              />
            }
            label={'Bonus Paid'}
          />
        );
      }}
    />
  );
};
